import * as z from 'zod';

import { addressQuerySchema } from '@/_containers/inputs/address/shared';
import { emailsQuerySchema } from '@/_containers/inputs/emails/shared/schema';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';
import { nullableNumericQuerySchema } from '@/_schemas/generic/numeric-value';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { contactPivotSchema } from './contact-pivot-schema';
import { contactQueryLinkerSchema } from './contact-query-linker-schema';
import { agreementTableSchema, marketingCampaignTableSchema } from './linked-schemas';

export const contactQuerySchema = z.object({
  ...contactQueryLinkerSchema.shape,

  username: z.string().nullable(),
  email: z.string().nullable(), // not in use
  emails: emailsQuerySchema,
  linked_in_url: z.string().nullable(),
  twitter_handle: z.string().nullable(),
  work_anniversary: z.string().nullable(),
  wedding_anniversary: z.string().nullable(),
  birth_day: z.number().nullable(),
  birth_month: z.number().nullable(),
  spouse_name: z.string().nullable(),
  children_names: z.string().nullable(),
  pet_names: z.string().nullable(),
  interests: z.string().nullable(),
  remote_worker: z.number().nullable(),
  registration_date: z.string().nullable(),

  phone_numbers: z.array(phoneNumberQuerySchema).nullish(),
  addresses: z.array(addressQuerySchema).nullish(),
  contacts_associated_with: z.array(contactQueryLinkerSchema).nullish(),

  friends: z.array(contactQueryLinkerSchema).nullish(),
  clients: z.array(companyQueryLinkerSchema).nullish(),
  primary_client: z.array(companyQueryLinkerSchema).nullish(),
  alternate_clients: z.array(companyQueryLinkerSchema).nullish(),

  pivot: contactPivotSchema.optional(),
  freshdesk: nullableNumericQuerySchema(),

  agreements: z.array(agreementTableSchema),
  marketing_campaigns: z.array(marketingCampaignTableSchema).nullish(),
});

export type ContactQuerySchema = z.infer<typeof contactQuerySchema>;

export const contactsQueryAllSchema = paginatedResponseSchema(contactQuerySchema);

export type ContactsQueryAllSchema = z.infer<typeof contactsQueryAllSchema>;
